// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"f4db314f","626":"2c8aaab7"}[chunkId] + ".chunk.js";
};